import { BaseControl } from "../base-control";

class ImageControlCtrl extends BaseControl {
  emptyModel = {display: {}, value: {}};
  
  fileUrl = null;
  copy = null;
  modal = null;
  uibModal = null;
  
  fieldWidth = null;
  fieldHeight = null;
  aspect = null;
  hasImage = false;
  imageSrc = "";

  constructor(BaseControlService, $scope, $uibModal, $element, $sce, $window) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, { $uibModal, $element, $sce, $window });
  }

  async initializeControlData() {
    await super.initializeControlData();
    this.fileUrl = await this.buildURL();
    this.$scope.$applyAsync();
    if (this.isPrint && this.fileUrl) await this.preloadImage();
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.updateFlags();
  }

  updateFlags() {
    this.hasImage = this.model.value?.body || this.model.value?.url;
    this.setImgSrc();
  }

  setImgSrc() {
    if (this.model.value?.body) this.imageSrc = `data:image/png;base64,${this.model.value?.body}`;
    else if (this.model.value?.url) this.imageSrc = this.fileUrl;
  }

  async preloadImage() {
    const img = new Image();
    img.src = this.fileUrl;
    img.className = 'bounded-img img-replacewith-canvas';
    try { await img.decode() } // Resolves when image is decoded and is safe to append to DOM.
    catch { console.error(`Error downloading image: ${this.fileUrl}`) }
    this.$element.find("#printed-image").replaceWith(img);
  }

  isSame(newVal, oldVal={}) {
    return angular.equals(newVal, oldVal);
  }
  
  onFileRead(file) {
    this.copy = angular.copy(this.model);
    const body = file.body || '';
    this.model.value = {
      filename: file.filename || '',
      body: file.ignoreEncoding ? body : btoa(body),
      ignoreEncoding: true
    };
  }
  
  reset() {
    if (this.copy) this.model = angular.copy(this.copy);
  }
  
  modalKeyDown(event) {
    if (!this.modal) return null;

    switch(event?.key) {
      case 'Escape':
        this.reset();
        return this.cancelModal();
      case 'Tab':
        return this.cancelModal();
      default:
        return;
    }
  }
  
  cancelModal(nextAction) { 
    this.modal.dismiss(nextAction);
    this.$timeout(() => this.modal = null);
  }
  
  doneModal() { 
    this.modal.close();
    this.$timeout(() => this.modal = null);
  }

  clearModal() { 
    this.copy = angular.copy(this.model);
    this.clearModel();
  }
  
  openModal() {
    if (this.modal) return null;
    if (!this.enabled) {
      if (this.fileUrl) this.$window.open(this.fileUrl, '_blank').focus();
      return;
    }
    
    const uibModal = { scope: this.$scope, size: "lg control-modal", backdrop: false };
    const $fieldEl = $(this.$element[0]).find('.form-control')[0];
    this.fieldWidth = $fieldEl.offsetWidth;
    this.fieldHeight = $fieldEl.offsetHeight;
    this.aspect = this.fieldHeight / this.fieldWidth;

    const bgImage = this.$element.closest('.render-template-window').children('img').first();
    this.pageDimensions = {
      width: bgImage.prop('naturalWidth'),
      height: bgImage.prop('naturalHeight')
    };
    this.fieldDimensions = {
      width: this.fieldWidth,
      height: this.fieldHeight
    };
    uibModal.template =
      `<file-upload-modal
          model="$ctrl.model.value"
          field-id="$ctrl.fieldId"
          modal-title="$ctrl.label"
          on-file-read="$ctrl.onFileRead(file, customId)"
          id="$ctrl.id"
          file="$ctrl.file"
          file-url="$ctrl.fileUrl"
          provider-file="$ctrl.model.value"
          cancel-modal="$ctrl.cancelModal()"
          done-modal="$ctrl.doneModal()"
          clear-modal="$ctrl.clearModal()"
          field-dimensions="$ctrl.fieldDimensions"
          page-dimensions="$ctrl.pageDimensions"
          original-size="$ctrl.token.options.originalSize"
          key-down="$ctrl.modalKeyDown(event, accept)"
          format-string="'image'">
        </file-upload-modal>`;
    
    this.modal = this.dom.openModal(this.$uibModal, uibModal, { triggerElement: this.$element });
    
    this.modal.result.then(
      closed => { 
        this.copy = null;
        this.cancelModal();
      },
      canceled => { 
        this.reset();
        this.cancelModal();
      }
    );
  }
  
  async buildURL() {
    const { url } = (this.model?.value || {});
    if (!url) return null;

    return await this.ts.getTemplateAttachmentUrl(url);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/image-control/image-control.component.html",
  controller: ImageControlCtrl
};